const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://dczeza9x5f.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://7v5vyfroh1.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.staging.teck.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.teck.forwoodsafety.com',
    WEBSOCKET: 'wss://hop65qwi7i.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;
